import { memo } from 'react';

import { cn } from '@air/utils-tailwind';

import { type IconType } from '~/types/icons';

export type ItemPickerSidebarNavItemProps = {
  icon: IconType;
  isActive: boolean;
  itemId: string;
  label: string;
  onClick: () => void;
};

export const ItemPickerSidebarNavItem = memo(
  ({ icon: Icon, isActive, itemId, label, onClick }: ItemPickerSidebarNavItemProps) => {
    return (
      <button
        aria-current={isActive ? 'true' : undefined}
        className={cn(
          'flex h-8 w-full items-center gap-2 rounded-4 px-2 text-left font-medium text-14 outline-none transition-colors ads:focus-visible:ring-focus focus-visible:ring-2 focus-visible:ring-blue-9 focus-visible:ring-inset',
          isActive
            ? 'ads:bg-subtle bg-gray-3 font-semibold ads:text-primary text-gray-12'
            : 'ads:text-secondary text-gray-11 ads:hover:bg-hover-subtle hover:bg-gray-3',
        )}
        data-item-id={itemId}
        data-testid="ITEM_PICKER_NAV_ITEM"
        onClick={onClick}
        type="button"
      >
        <Icon className="size-4 shrink-0" />
        {label}
      </button>
    );
  },
);

ItemPickerSidebarNavItem.displayName = 'ItemPickerSidebarNavItem';
